import React from 'react';
import { Pill, Cluster } from '@nearst/ui';

import { NavigationCell } from '../NavigationCell';
import { useIsChain } from '@utils/useIsChain';

const Pills = ({ row }) => {
	const isChain = useIsChain();
	if (isChain) return null;
	return (
		<Cluster space="0.5rem">
			{!row.hasIssues && !row.hidden && (
				<Pill colour="green" data-cy="inventory-pill-active">
					Active
				</Pill>
			)}
			{row.hasIssues && (
				<Pill colour="grey" data-cy="inventory-pill-inactive">
					Inactive
				</Pill>
			)}
			{row.hidden && (
				<Pill colour="blue" data-cy="inventory-pill-hidden">
					Hidden
				</Pill>
			)}
		</Cluster>
	);
};

const Status = ({ row }) => {
	const isChain = useIsChain();
	if (isChain) return null;
	return (
		<NavigationCell barcode={row.barcode}>
			<Pills row={row} />
		</NavigationCell>
	);
};

export { Status, Pills };
